const MediaType = {
    IMAGE: "IMAGE",
    AUDIO: "AUDIO"
};

export default MediaType;
